import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { PageHeader } from "../components/PageHeader";
import { PlayerProfileHero } from "../components/PlayerProfileHero";
import api from "../lib/api";

export default function PlayerDetailPage() {
  const { playerId } = useParams();
  const query = useQuery({ queryKey: ["players"], queryFn: () => api.get("/users").then((result) => result.data) });
  const player = (query.data || []).find((item) => item.id === playerId);
  return <><PageHeader title="Perfil do jogador" subtitle="Elenco dos Perninhas" back /><section className="page-content" data-testid="player-detail-page">{player ? <PlayerProfileHero player={player} /> : <div className="empty-state"><h2>Jogador não encontrado</h2></div>}</section></>;
}